/* unplugin-vue-components disabled */import { render } from "./SongList.vue?vue&type=template&id=284a0e24&scoped=true"
import script from "./SongList.vue?vue&type=script&lang=js"
export * from "./SongList.vue?vue&type=script&lang=js"

import "./SongList.vue?vue&type=style&index=0&id=284a0e24&lang=less&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-284a0e24"]])

export default __exports__